<script lang="ts" setup>
import { toTypedSchema } from '@vee-validate/zod';
import { useField } from 'vee-validate';
import { inject, ref } from 'vue';
import { z } from 'zod';
import VInput from '@shared/form/VInput/VInput.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { isDisabledInjectionKey, isReadonlyInjectionKey } from '../keys';

const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });
const maxLength = 128;
const { errors, value } = useField(
  'website',
  toTypedSchema(
    z
      .string()
      .regex(/^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,63}(\/[^\s:]*)?$/, {
        message: 'Ongeldige website',
      })
      .max(maxLength)
      .optional()
      .nullable()
      .or(z.literal('')),
  ),
);
const fieldId = 'relatiegegevens-website';

function formUrl(input: string) {
  return input.startsWith('http') ? input : `https://${input}`;
}
</script>

<template>
  <FieldRowV2 :errors label="Website" :label-for="fieldId">
    <VInput
      v-if="!hasReadonlyParent"
      v-model="value"
      :has-error="!!errors.length"
      :id="fieldId"
      :is-disabled="hasDisabledParent"
      type="url"
      :max-length="maxLength"
    />
    <div v-else>
      <a target="_blank" rel="noopener noreferrer" :href="formUrl(value)" v-if="value">
        {{ value }}
      </a>
      <template v-else>-</template>
    </div>
  </FieldRowV2>
</template>
